export default __webpack_public_path__ + "static/media/photo--lg--workshop.a9625953.jpg";